import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-17eca943"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "20px"
  }
}, null, -1));
const _hoisted_5 = {
  style: {
    "margin-left": "20px"
  }
};
const _hoisted_6 = {
  style: {
    "margin-top": "10px",
    "display": "flex",
    "justify-content": "end"
  }
};
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { Search, Refresh } from '@element-plus/icons-vue';
import tableComponent from './components/Table';
import { getLogPage } from '@/api/sys';
import usePagination from '@/hooks/usePagination';
import { tableDataSchemas } from './config';
export default {
  __name: 'index',
  setup(__props) {
    const tableData = ref([]);

    // loading效果
    const loading = ref(false);
    const {
      currentPage,
      total,
      pageSize,
      setPageSize,
      setCurrentPage,
      setTotal
    } = usePagination();
    const requestUri = ref('');
    const getData = async () => {
      loading.value = true;
      const res = await getLogPage({
        currentPage: currentPage.value,
        pageSize: pageSize.value,
        requestUri: requestUri.value
      });
      setTotal(res.total);
      tableData.value = res.records;
      loading.value = false;
    };
    const handleRefresh = () => {
      requestUri.value = '';
      getData();
    };

    /**
     * 更改当前页码
     * @param {*} val
     */
    const handleCurrentChange = val => {
      setCurrentPage(val);
      getData();
    };
    const handleChangeSize = e => {
      setPageSize(e);
      getData();
    };
    const router = useRouter();
    const handleInfo = row => {
      router.push(`/log/${row.id}`);
    };
    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_pagination = _resolveComponent("el-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        shadow: "never",
        class: "title-card",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
          modelValue: requestUri.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => requestUri.value = $event),
          placeholder: "请输入请求uri",
          style: {
            "width": "300px"
          }
        }, null, 8, ["modelValue"]), _hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
          type: "primary",
          icon: _unref(Search),
          onClick: getData
        }, {
          default: _withCtx(() => [_createTextVNode(" 查询 ")]),
          _: 1
        }, 8, ["icon"]), _createVNode(_component_el_button, {
          icon: _unref(Refresh),
          onClick: handleRefresh
        }, {
          default: _withCtx(() => [_createTextVNode(" 重置 ")]),
          _: 1
        }, 8, ["icon"])])])])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(tableComponent), {
          onInfo: handleInfo,
          tableData: tableData.value,
          loading: loading.value,
          schemas: _unref(tableDataSchemas),
          currentPage: _unref(currentPage),
          pageSize: _unref(pageSize)
        }, null, 8, ["tableData", "loading", "schemas", "currentPage", "pageSize"]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_pagination, {
          onCurrentChange: handleCurrentChange,
          onSizeChange: handleChangeSize,
          "page-sizes": [12, 24, 36],
          "current-page": _unref(currentPage),
          "page-size": _unref(pageSize),
          total: _unref(total),
          layout: "total, sizes, prev, pager, next, jumper"
        }, null, 8, ["current-page", "page-size", "total"])])]),
        _: 1
      })]);
    };
  }
};